import React, { Component } from 'react';
import { FRONTEND_BASE_URL, PERSONAL_DATA_PROCESSING_CONSENT_URL } from '../../config';

var agreedButtonsCount = 0

class AgreedButton extends Component {
    constructor(props) {
        super(props)
        this.state = {
            labelClass: '',
            ofertaConsent: props.agreed,
            personalDataConsent: props.agreed,
        }

        this.name = 'AgreedButtonItem' + agreedButtonsCount
        agreedButtonsCount += 1
    }

    render() {
        return (
            <>
                {this.getButton()}
                {this.getCheckboxes()}
            </>
        )
    }

    getButton = () => {
        return (
            <input className="tickets-button-primary tickets-button-agreed"
                disabled={!this.props.agreed}
                title={this.props.agreed ? '' : this.props.buttonTitle}
                type="submit"
                onClick={this.props.onClick}
                value={this.props.buttonText} />
        )
    }

    getCheckboxes = () => {
        return (
            <div className="tickets-agreement-text">
                <div>
                    <input 
                        className="checkbox-inline"
                        id={this.name}
                        type="checkbox"
                        checked={this.state.ofertaConsent}
                        onChange={this.handleOfertaCheckboxChange}/>
                    <label 
                        className='checkbox-label' 
                        htmlFor={this.name}>
                            Я согласен с&nbsp;
                            <a 
                                href={FRONTEND_BASE_URL + '/rules'} 
                                onClick={(e) => this.handleLinkAction(e, this.props.showRules)}>
                                условиями приобретения
                            </a>
                            &nbsp;и&nbsp;
                            <a 
                                href={FRONTEND_BASE_URL + '/public_offer'} 
                                onClick={(e) => this.handleLinkAction(e, this.props.showOffer)}>
                                офертой
                            </a>
                    </label>
                </div>
                <div>
                    <input 
                        className="checkbox-inline"
                        id={this.name}
                        type="checkbox"
                        checked={this.state.personalDataConsent}
                        onChange={this.handlePersonalDataConsentCheckboxChange}/>
                    <label 
                        className='checkbox-label' 
                        htmlFor={this.name}>
                            Даю согласие на обработку моих персональных данных для&nbsp;
                            <a href={PERSONAL_DATA_PROCESSING_CONSENT_URL} target="_blank" rel="noopener noreferrer">
                                покупок
                            </a>
                    </label>
                </div>
            </div>
        )
    }

    handleLinkAction = (event, action) => {
        event.preventDefault()
        action()
    }

    handleOfertaCheckboxChange = (event) => {
        this.setState({ofertaConsent: event.target.checked})
        this.props.onUpdate({agreed: event.target.checked && this.state.personalDataConsent})
    }

    handlePersonalDataConsentCheckboxChange = (event) => {
        this.setState({personalDataConsent: event.target.checked})
        this.props.onUpdate({agreed: this.state.ofertaConsent && event.target.checked})
    }
}

export default AgreedButton
